import { render, staticRenderFns } from "./examRoomStyle.vue?vue&type=template&id=4ed094cf&scoped=true"
import script from "./examRoomStyle.vue?vue&type=script&lang=ts"
export * from "./examRoomStyle.vue?vue&type=script&lang=ts"
import style0 from "./examRoomStyle.vue?vue&type=style&index=0&id=4ed094cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed094cf",
  null
  
)

export default component.exports